export default "__VITE_ASSET__9b09770b__"